// send offers to buyer via checkbox list
export function sendOffers() {
    const form = document.querySelector<HTMLFormElement>("#advice-offers");

    if (!form) {
        return;
    }

    const inputElements = form.getElementsByTagName(
        "input",
    ) as HTMLCollectionOf<HTMLInputElement>;
    const submitButton =
        document.querySelector<HTMLFormElement>(".fixed-button");
    let checkboxes = [] as HTMLInputElement[];

    for (let i: number = 0; i < inputElements.length; i++) {
        if (inputElements[i].type == "checkbox") {
            inputElements[i].addEventListener("change", () => {
                checkboxes = Array.from(inputElements).filter((i) => i.checked);

                if (submitButton) {
                    if (checkboxes.length > 0) {
                        submitButton.style.display = "block";
                    } else {
                        submitButton.style.display = "none";
                    }
                }
            });
        }
    }

    form.addEventListener("submit", (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();

        form.submit();
        return;
    });
}
